import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {
    TransformResponse
} from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction as setAppointmentsTable,
    setSelectedPatient,
    reinitAction,
    reInitOnPatientChangeAction
} from 'one-state-appointments';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format,substract_daysoncurrentdate,add_daysoncurrentdate} from 'one-util-date';
import { Disposition } from 'one-model-local';
export const enum Types {
    SETAPPOINTMENTS = 'set-appointments/set',
    SETAPPOINTMENTSSUCCESS = 'set-appointments-success',
    CANCELAPPT = 'one-state-appointments/cancel-appt',
    SETCANCELAPPT='one-state-appointments/push-cancel-appt',
    STORE_DISPOSITION_CODE = "store-disposition-code",
    CONFIRMAPPT = 'one-state-appointments/confirm-appt',
    SETCONFIRMAPPT='one-state-appointments/push-confirm-appt',
    UPDATEAPPT = 'one-state-appointments/update-appt',
    SETUPDATEAPPT='one-state-appointments/push-update-appt',
}

const setAppointments = (payload: any) => ({ type: Types.SETAPPOINTMENTS, payload });
const pushtoApptsTable = (payload: any) => setAppointmentsTable(payload);
const pushtoCancelAppt = (payload:any) => ({type:Types.SETCANCELAPPT, payload});
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
const pushtoConfirmAppt = (payload: any) => ({type: Types.SETCONFIRMAPPT, payload});
const pushtoUpdateAppt = (payload:any) => ({type:Types.SETUPDATEAPPT, payload});


/**
 * This Fuction will fetch the data of upcoming appts
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchApptsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const {
            server,
            log,
            agentId,
            settings:
            {
                epicendpoints: {
                    patientappointment,
                    apitoken
                },
                uisettings: {
                    dashboardapiconfig: {
                        patientappointment : patientappointmentApi
                    }
                },
                appointment_config: {
                    past_appointment_days,
                    future_appointment_days
                },
                compatible : { consolidated_api_invocation, contact_center_type },
            }
        } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE, Types.SETAPPOINTMENTSSUCCESS) : ofType(SETSELECTED, Types.SETAPPOINTMENTSSUCCESS),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let dataresponse: any = action.payload;
                log.debug("one-epics", "fetch Appointments request", dataresponse);
                const getRequest = (datares: any) => {
                    if (datares?.id) {

                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        let startdate = substract_daysoncurrentdate(past_appointment_days, 'MM/DD/YYYY');
                        let enddate = add_daysoncurrentdate(future_appointment_days, 'MM/DD/YYYY');
                        const data = {
                            "PatientID": datares.id,
                            //"PatientID": "E5555",
                            //Mirth is taking care of Start and End Date
                            "StartDate": startdate,
                            "EndDate": enddate
                        }
                        const response = server.post({
                            path: patientappointment,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,upcomingappts-epic",
                                    "fetch-Appt-epic", {
                                    responseresult
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "Appointments",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug("one-epics", "fetch Appointments response", response);
                        return from(response)
                    } else {
                        return from([]);
                    }

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!patientappointmentApi) return []
                return getRequest(dataresponse).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                setSelectedPatient(dataresponse.id)
                            ];
                            actions.push(setAppointments(response));
                            if (response && (response.status >= 400 || response.type == "error")) {
                                actions.push(addAction(response));
                                let disp: Disposition = { value: "1000" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta01 = dataresponse.id;
                                disp.meta02 = response.status;
                                disp.meta03 = response.erroritems?.[0]?.error_detail;
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "183" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta01 = dataresponse.id;
                                disp.meta02 = '200';
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * This Function is used to fetch appointments
 * @param context contains settings json etc ..
 */
export const pushApptsTableEpic = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETAPPOINTMENTS),
            mergeMap((action: any) => {
                /**
                 * @param response contains the appointment response
                 */
                let response = action.payload;
                log.debug("one-epics", "fetch Appointments request", response);
                if (response) {
                    const performAppTransformation = (datares: any) => {
                        let result = TransformResponse(datares, context, state$.value?.appointments?.selectedPatientId);
                        log.debug("one-epics", "fetch Appointments response", result);
                        return from([result]);
                    }
                    return performAppTransformation(response).
                        pipe(
                            map((transformresponse: any) => pushtoApptsTable(transformresponse))
                        )
                }
                else{
                    return from([]);
                }
            })

        )
    }
);

/**
 * This Function is used to cancel the Appointment
 * @param context haiving settings json etc..
 */
export const pushCancelApptToEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId, settings: { compatible, epicendpoints: { cancelappointment, apitoken } } } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.CANCELAPPT),
            mergeMap((action: any) => {
                /**
                 *  @param dataresponse conatains the payload data for cancel appt.
                 */
                var dataresponse = action.payload;
                log.debug("one-epics", "push Cancel Appointment request", dataresponse);
                const getRequest = (dataresponse1: any) => {
                    if (dataresponse1) {
                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        // const data = {
                        //     "PatientID": dataresponse1.PatientID,
                        //     "Reason": dataresponse1.Reason,
                        //     "Comment": dataresponse1.Comment
                        // }
                        //+ "?PatientID=" + dataresponse.PatientID + "&Reason=" + dataresponse.Reason + "&Comment=" + dataresponse.Comment + ""
                        const response = server.handle({
                            path: cancelappointment + "?PatientID=" + dataresponse1.PatientID +"&PatientIDType=" + dataresponse1.PatientIDType + "&ContactID=" + dataresponse1.ContactID + "&ContactIDType=" + dataresponse1.ContactIDType + "&Reason=" + dataresponse1.Reason + "&Comment=" + dataresponse1.Comment + "",
                            //data: data,
                            headers: headers
                        }, 'delete')
                            .then((responsedata: any) => responsedata)
                            .catch((responseresultdata: any) => {
                                log.error(
                                    "ccw-gadget,cancelappt-epic",
                                    "fetch-CancelAppt-to-epic", {
                                    responseresultdata
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "CancelAppointment",
                                    type: "error",
                                    status: responseresultdata?.status,
                                    erroritems: responseresultdata?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug("one-epics", "Cancel Appointments response", response);
                        return from(response)
                    } else {
                        return from([]);
                    }

                }

                return getRequest(dataresponse)
                    .pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushtoCancelAppt(response)
                            ];
                            if (response && (response.status >= 400 || response.type == "error")) {
                                actions.push(addAction(response));
                            }
                            //Disposition Framework
                            if (Array.isArray(response) && response.length > 0) {
                                let val = response[0];
                                if (val && val.Success && val.Success === '1') {
                                    let disp: Disposition = { value: "176" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                    }
                                    disp.meta01 = dataresponse.PatientID;
                                    disp.meta02 = dataresponse.Reason;
                                    disp.meta03 = 'client';
                                    actions.push(pushToDisposition(disp));
                                } else {
                                    let disp: Disposition = { value: "991" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                    }
                                    disp.meta01 = dataresponse.PatientID;
                                    disp.meta02 = dataresponse.Reason;
                                    disp.meta03 = 'client';
                                    actions.push(pushToDisposition(disp));
                                }
                            }
                            //Disposition invocation in case of API down/failed
                            if (response && (response.status >= 400 || 
                                (response.type === 'error' && response.source === 'CancelAppointment'))) {
                                    let disp: Disposition = { value: "991" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                    }
                                    disp.meta01 = dataresponse.PatientID;
                                    disp.meta02 = dataresponse.Reason;
                                    disp.meta03 = 'client';
                                    actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * This Function is used to confirm the Appointment
 * @param context having settings json etc..
 */
 export const pushConfirmApptToEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, alertnotification, agentId, teamName, settings: { compatible, servers, epicendpoints: { confirmappointment, apitoken } } } = context;
        const { contact_center_type, finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.CONFIRMAPPT),
            mergeMap((action: any) => {
                /**
                 *  @param dataresponse conatains the payload data for cancel appt.
                 */
                let dataresponse = action.payload;
                log.debug("one-epics", "push Confirm Appointment request", dataresponse);
                const getRequest = (dataresponse1: any) => {
                    if (dataresponse1) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data ={

                            "CommunicationType" : dataresponse1.CommunicationType,
                        
                            "ContactID" : dataresponse1.ContactID,
                        
                            "ContactIDType" : dataresponse1.ContactIDType,
                        
                            "NotificationResponse" : "Confirmed",
                        
                            "PatientID" : dataresponse1.PatientID,
                        
                            "PatientIDType" : dataresponse1.PatientIDType,
                        
                            "UserID" : dataresponse1.UserID,
                        
                            "UserIDType" : dataresponse1.UserIDType
                    }
                        let response;
                        if (finesse_proxy_service) {
                           //do nothing

                        } else {
                         response = server.put({
                            path: confirmappointment,
                            data:data,
                            headers
                        })
                            .then((responsedata: any) => responsedata)
                            .catch((responseresultdata: any) => {
                                log.error(
                                    "ccw-gadget,confirmappt-epic",
                                    "fetch-ConfirmAppt-to-epic", {
                                    responseresultdata
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "ConfirmAppointment",
                                    type: "error",
                                    status: responseresultdata?.status,
                                    erroritems: responseresultdata?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                                .then((responsedata: any) => responsedata)
                                .catch((responseresultdata: any) => {
                                    log.error(
                                        "ccw-gadget,confirmappt-epic",
                                        "fetch-ConfirmAppt-to-epic", {
                                        responseresultdata
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "ConfirmAppointment",
                                        type: "error",
                                        status: responseresultdata?.status,
                                        erroritems: responseresultdata?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug("one-epics", "Confirm Appointments response", response);
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }

                }

                return getRequest(dataresponse)
                    .pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushtoConfirmAppt(response)
                            ];
                            if (response && (response.status >= 400 || response.type == "error")) {
                                actions.push(addAction(response));
                            }

                            //Disposition Framework
                            const disp: Disposition = { value: "1010" };
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                            } 
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                            } 
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                            } else if(contact_center_type==="genesys"){
                                disp.meta00 = sessionStorage.getItem("name");
                                disp.meta01 = sessionStorage.getItem("agentName");
                              }
                              else if(contact_center_type==="twilio"){
                                disp.meta00 = sessionStorage.getItem("twilio_userid");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="ringcentral"){
                                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="inContact"){
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                              }
                              else if(contact_center_type==="vonage"){
                                disp.meta00 = sessionStorage.getItem("vonage_userid");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="wxcc"){
                                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                disp.meta01 = "";
                              } 
                            else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value?.choosecaller?.callId;
                            }
                            disp.meta01 = teamName;
                            disp.meta02 = dataresponse.PatientID;
                            disp.meta03 = dataresponse.deptID;
                            disp.meta04 = dataresponse.visitTypeID;
                            disp.meta05 = dataresponse.providerID;
                            disp.meta06 = 'Appointment Confirmed Successfully';

                            if (response && (response.status >= 400 ||
                                (response.type === 'error' && response.source === 'ConfirmAppointment'))) {
                                 disp.meta06 = 'Failed to Confirm an Appointment';
                                disp.value = "2022";
                            }
                            actions.push(pushToDisposition(disp));

                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearAppointmentsEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, appointments-epic",
            "clear-appointments-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,PATIENTRESET),
            map(action => reinitAction())
        )

    }
);

/**
 * Listen for component clear when patient is changed in the subject card
 * @param context  contains logger which is used for logging
 */
export const clearAppointmentsonPatientChangeEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, appointments-epic",
            "clear-appointments-epic", {
        });
        return action$.pipe(
            ofType(SETSELECTED, SETPATIENTSELECTED),
            map(action => reInitOnPatientChangeAction())
        )

    }
);


export const pushUpdateApptToEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,teamName, settings: { compatible, epicendpoints: { updateappointment, apitoken } } } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.UPDATEAPPT),
            mergeMap((action: any) => {
                /**
                 *  @param dataresponse conatains the payload data for update appt.
                 */
                var dataresponse = action.payload;
                log.debug("one-epics", "push Update Appointment request", dataresponse);

                const getRequest = (dataresponse1: any) => {
                    if (dataresponse1) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        // const data = {
                        //     "PatientID": dataresponse1.PatientID,
                        //     "Reason": dataresponse1.Reason,
                        //     "Comment": dataresponse1.Comment
                        // }
                        //+ "?PatientID=" + dataresponse.PatientID + "&Reason=" + dataresponse.Reason + "&Comment=" + dataresponse.Comment + ""
                        const response = server.put({
                            path: updateappointment + "?PatientID=" + dataresponse1.PatientID +"&PatientIDType=" + dataresponse1.PatientIDType+ "&UserID="+dataresponse1.UserID+"&UserIDType="+dataresponse1.UserIDType + "&ContactID=" + dataresponse1.ContactID + "&ContactIDType=" + dataresponse1.ContactIDType +"",
                            data: {"Notes":dataresponse1.notes},
                            headers: headers
                        }, 'delete')
                            .then((responsedata: any) => responsedata)
                            .catch((responseresultdata: any) => {
                                log.error(
                                    "ccw-gadget,updateappt-epic",
                                    "fetch-UpdateAppt-to-epic", {
                                    responseresultdata
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "UpdateAppointment",
                                    type: "error",
                                    status: responseresultdata?.status,
                                    erroritems: responseresultdata?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug("one-epics", "Update Appointments response", response);
                        return from(response)
                    } else {
                        return from([]);
                    }

                }

                return getRequest(dataresponse)
                    .pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushtoUpdateAppt(response)
                            ];
                            if (response && (response.status >= 400 || response.type == "error")) {
                                actions.push(addAction(response));
                            }
                            //Disposition Framework
                            if (Array.isArray(response) && response.length > 0) {
                                let val = response[0];
                                if (val && val.Success && val.Success === '1') {
                                    let disp: Disposition = { value: "2035" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                    }
                                    disp.meta01 = teamName;
                                    disp.meta02 = dataresponse.PatientID;
                                    disp.meta03 = dataresponse.Reason;
                                    disp.meta04 = 'Appointment Notes updated successfully';
                                    actions.push(pushToDisposition(disp));
                                } else {
                                    let disp: Disposition = { value: "2035" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                    }
                                    disp.meta01 = teamName;
                                    disp.meta02 = dataresponse.PatientID;
                                    disp.meta03 = dataresponse.Reason;
                                    disp.meta04 = 'Appointment Notes updated successfully';
                                    actions.push(pushToDisposition(disp));
                                }
                            }
                            //Disposition invocation in case of API down/failed
                            if (response && (response.status >= 400 || 
                                (response.type === 'error' && response.source === 'UpdateAppointment'))) {
                                    let disp: Disposition = { value: "2036" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                    }
                                    disp.meta01 = teamName;
                                    disp.meta02 = dataresponse.PatientID;
                                    disp.meta03 = dataresponse.Reason;
                                    disp.meta04 = 'Failed to update the appointment notes';
                                    actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
